import React from 'react'
import GenericReport from '../GenericReport'

const TreatmentCategoryAnalysisPage: React.FC = () => {
  return <GenericReport reportId={6} />
}

export default TreatmentCategoryAnalysisPage
